import { useQuery } from '@tanstack/react-query'

import { clients } from '@digital-commerce/shared-utils'

import createDigitalCommerceCartClient from '../clients/bff'

const client = createDigitalCommerceCartClient(clients.bff)

const useValueProps = ({ customerType, cartType }) => {
  return useQuery({
    queryKey: ['/cart/value-props', customerType, cartType],
    queryFn: ({ queryKey: [, prop1, prop2] }) => {
      return client.getValueProps(prop1, prop2)
    }
  })
}

export default useValueProps
